
import './transactions.scss';

import InOut from './../../../assets/images/icons/inout.png';
import CashIn from './../../../assets/images/icons/cash-in.png';
import Timer from './../../../assets/images/icons/timer.png';
import Failed from './../../../assets/images/icons/failed.png';

import React, { FunctionComponent } from "react";
import { useAppDispatch } from '../../../features';
import { setLoaderStatus } from '../../../store/LoaderSlice';
import { getReceiptRequest, getWithdrawalReceipt } from '../../../store/ReceiptSlice';
import { setModalSignInUp } from '../../../store/AppSlice';
import { modalTypeEnum } from '../../../types/modal';
import { formatDate } from '../../../types/helpers';
import { statusToActivities, Transactionlabel } from '../../../types/transactions';
import { changeClass, shortenLargeNames, textFormatterWalletHiddenChars } from '../../../utils/textFormatter';
import { Amount } from '../../utils/amount/amount';

type TransactionsListType = {
    items: Array<any>
}

export const TransactionList: FunctionComponent<TransactionsListType> = ({ items }) => {
    const dispatch = useAppDispatch();

    const imgType = (x: any) => {
        let Img = CashIn;
        if (x.activity === 'withdrawal') Img = CashIn;
        if (x.activity === 'charge') Img = InOut;
        if (x.event.status === 'expired') Img = Failed;
        if (x.event.status === 'pending') Img = Timer;
        return Img;
    }

    const handleActivityClick = async (x: any) => {

        dispatch(setLoaderStatus(true))

        if (x.activity === 'charge') await dispatch(getReceiptRequest(x.event.id));
        if (x.activity === 'withdrawal') await dispatch(getWithdrawalReceipt(x.event.id));

        dispatch(setModalSignInUp(modalTypeEnum.receipt));
        dispatch(setLoaderStatus(false))

    }

    const customCssClass = (x: any) => {
        let css = 'img-wrapper-history';
        if (x.activity === 'charge') css += ' in';
        if (x.activity === 'withdrawal') css += ' out';
        if (x.event.status === 'expired') css += ' expired';
        if (x.event.status === 'pending') css += ' updating';
        return css;
    }

    const formattedDate = (x: any) => {
        if (x.event.status === "expired") {
            return "EXPIRADO";
        }
        return formatDate(x.event.updated_at?.toString());
    };
    const historyLabel = (d: any) => Transactionlabel(d);
    const statusLabel = (x: any) => statusToActivities(x);

    return (
        <ul className='history-list'>
            {items.map((x, index) => {


                return (
                    <li key={index} onClick={() => handleActivityClick(x)}>
                        <div className={"transaction-info " + index + 1}>
                            <div className={customCssClass(x)}>
                                <img src={imgType(x)} alt="" />
                            </div>
                            <p>
                                <b className={changeClass(x)}>
                                    {historyLabel(x.activity)}
                                </b>
                                <b className='bold poppins-bold'>
                                    {
                                        x.tags && (
                                            <>
                                                <span>( {x?.tags?.npos_name} )</span>
                                                <br/>
                                            </>
                                        )
                                    }
                                    
                                    {
                                        x.activity === 'charge' ?
                                            shortenLargeNames(x.event.payer_name) || "---" :
                                            textFormatterWalletHiddenChars(x.event.payee, 6)
                                    }
                                </b>
                                <small className={x?.event?.status === 'expired' ? `expired` : ``}>
                                    {formattedDate(x)}
                                </small>
                                <small>
                                    {x.event.is_npos}
                                </small>

                            </p>
                        </div>
                        <div className={`history-value ${x?.event?.status === 'expired' ? 'expired' : ''}`}>
                            <Amount
                                value={(x.event.status === 'waiting-offer' && '0' || x.event.amount)}
                                format={false}
                                {...(x.activity !== 'charge' && { currency: 'USDT' })}
                                isReceipt={true} />

                            <div className={`status ${changeClass(x)}`}>
                                {statusLabel(x)}
                            </div>
                        </div>
                    </li>
                );
            })}
        </ul>
    )
}